import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Typography,
    FormControl,
    Pagination,
    IconButton,
    Tooltip,
    Modal,
    Box,
    Button,
    Card,
    CardHeader,
    CardContent,
    Divider,
    TextField,
    Grid,
    Stack,
    Select
} from "@mui/material";
import Alert from '@mui/material/Alert';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import Autocomplete from '@mui/material/Autocomplete';
import MenuItem from '@mui/material/MenuItem';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Chip from '@mui/material/Chip';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import SearchIcon from '@mui/icons-material/Search';
import LinearProgress from '@mui/material/LinearProgress';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import EditIcon from "@mui/icons-material/Edit";
import BulkOrderCreateDrawer from '../../pages/General/BulkOrderCreateDrawer'
import BulkOrderDetailsDrawer from '../../pages/General/BulkOrderDetailsDrawer'
import { getBulkLabels,resetBulkLabel } from '../../pages/BulkOrder/bulkPrintSlice';
import { fetchBulkOrderShipments } from '../../pages/BulkOrder/bulkOrderDetailsSlice';
import Date from '../../pages/General/Date'
import {
    DataGrid,
    GridToolbarContainer,
    GridFooterContainer
} from '@mui/x-data-grid';
// import {
//     DataGridPro,
//     GridToolbarContainer,
//     GridFooterContainer,
//     useGridApiRef,
//     GridAutosizeOptions
// } from '@mui/x-data-grid-pro';
import { fetchBulkOrderReference, fetchBulkOrderDetail,bulkReferenceCooUpdateData, resetBulkOrderNotifications } from '../../pages/BulkOrder/bulkOrderSlice';
import { fetchCountry, fetchState,fetchMultiStates } from '../../pages/General/countryStateCitySlice';
import {
    printBulkLabels
} from '../../pages/Orders-new/ordersSlice';
//Custom Components Import Starts
import NorowsData from '../General/NorowsData'
import BulkOrderDrawer from '../General/BulkOrderDrawer'
import Notification from '../General/Notification'
import Filters from './Filters'
import Search from './Search'
import Printer from '../../pages/General/Printer'
import PageSearch from '../../pages/General/PageSearch'
//Custom Components Import Ends

const BulkOrderPage = () => {

    const dispatch = useDispatch();
    const orders = useSelector(state => state.ordersNew);
    const getprofile = useSelector(state => state.profile.profile);
    const bulkorder = useSelector(state => state.bulkorder && state.bulkorder.bulkorderdata);
    const cooUpdate = useSelector(state => state.bulkorder && state.bulkorder.cooReferenceUpdate);
    const profile = useSelector(state => state.auth);
    const country_code = useSelector(state => state.countrystate.country);
    const filteredCountryData = country_code.data.filter(({ code }) => code );
    const [meta, setMeta] = useState(bulkorder.meta);
    const [bulkOrderDrawerVisible, setBulkOrderDrawerVisible] = useState(false);
    const [bulkOrderCreateDrawerVisible, setBulkOrderCreateDrawerVisible] = useState(false);
    const [referenceId, setReferenceId] = useState("");
    const [showFilter, setShowFilter] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [cooModalVisible, setCooModalVisible] = useState(false);
    const [bulkReferenceId, setBulkReferenceId] = useState("");
    const [checkedIds, setCheckedIds] = useState([]);
    const [checkedItems, setCheckedItems] = useState([]);
    const [printUrl, setPrintUrl] = useState("")
    const [isPrinted, setIsPrinted] = useState(true)
    const [breakdownDrawerVisible, setBreakdownDrawerVisible] = useState(false);
    const [breakdownRefId, setBreakdownRefId] = useState(null);
    const [breakdownType, setBreakdownType] = useState('all');
    const [pageNumber, setPageNumber] = useState("")
    const initialValues = {
        "coo": "",
        "hs_tariff_code": "",
        "update":"All"
    }
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState({});

    // HS Code Formatter (integrated for modal state)
    const formatHsCode = (val) => {
        const raw = val.replace(/\D/g, '');
        if (raw.length === 10) {
            return `${raw.slice(0, 4)}.${raw.slice(4, 6)}.${raw.slice(6, 8)}.${raw.slice(8, 10)}`;
        }
        return val;
    };

    const handleHsBlur = () => {
        const formatted = formatHsCode(values.hs_tariff_code);
        setValues(prev => ({ ...prev, hs_tariff_code: formatted }));
        validator({ hs_tariff_code: formatted });
    };

    const validator = (fieldValues = values) => {
        let temp = { ...errors };

        // HS Code Format Validation (Optional but must be 10 digits if provided)
        if ('hs_tariff_code' in fieldValues) {
            const raw = fieldValues.hs_tariff_code.replace(/\D/g, '');
            temp.hs_tariff_code = (raw && raw.length !== 10) ? "HS Code must be 10 digits." : "";
        }

        // Logic: Block submit only if BOTH are empty
        // Individual field errors are handled during typing/blur
        setErrors(temp);

        if (fieldValues === values) {
            const isHsValid = temp.hs_tariff_code === "";
            const hasData = values.coo !== "" || values.hs_tariff_code !== "";
            if (!hasData) {
                setErrors(prev => ({ ...prev, coo: "Provide either Country or HS Code." }));
            }
            return isHsValid && hasData;
        }
    };

    const [bulkdrawershow, setbulkdrawershow] = useState(false);

    const bulkOrderCreateCallback = (item) => {
        setBulkOrderCreateDrawerVisible(true)
    }
    const bulkOrderCreateOnClose = (values) => {
        setBulkOrderCreateDrawerVisible(false);
    };
    const bulkOrderCallback = (item) => {
        setReferenceId(item)
        dispatch(fetchBulkOrderDetail(item));
        setBulkOrderDrawerVisible(true)
        setbulkdrawershow(true)
        let userid=profile && profile.profile && profile.profile.id
        let referenceid=item
        dispatch(getBulkLabels(referenceid))
    }
    const bulkOrderOnClose = (values) => {
        setBulkOrderDrawerVisible(false);
    };

    const cooEditAction = (_id) => {
        setCooModalVisible(true)
        setBulkReferenceId(_id)
    }
    const onExportClick = (_id) => {
        let url = process.env.REACT_APP_API_DOMAIN +`/labelgen/bulk-shipments/successful-shipments-export?reference_id=${_id}`;
        window.open(url,"_blank")
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    };
    const tagstyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper'
    };

    const onSelectionChange = (currentSelectedIds, currentAllItems) => {
        let tempCheckedIds = [...checkedIds]
        let tempCheckedItems = [...checkedItems];
        currentAllItems.map((item) => (
            checkBoxCompute(tempCheckedIds, tempCheckedItems, item, currentSelectedIds)
        ))
        setCheckedIds(tempCheckedIds)
        setCheckedItems(tempCheckedItems)
    }

    const checkBoxCompute = (tempCheckedIds, tempCheckedItems, item, currentSelectedIds) => {
        const index = tempCheckedIds.indexOf(item._id);
        const method = (currentSelectedIds.indexOf(item._id) > -1)
        if (method) {
            if (index === -1) {
                tempCheckedIds.push(item._id);
                tempCheckedItems.push(item)
            }
        } else if (!method) {
            if (index > -1) {
                tempCheckedIds.splice(index, 1);
                tempCheckedItems.splice(index, 1);
            }
        }
        return [tempCheckedIds, tempCheckedItems];
    }

     const printLabelBulk = () => {
        let urls = []
        checkedItems.forEach((item) => {
            let row = typeof item == "object" ? JSON.parse(JSON.stringify(item)) : {}
            if (item && item.bulk_label_url) {
                urls.push(item.bulk_label_url)
            }
        })
        if (urls.length !== 0) {
            dispatch(printBulkLabels(urls, getprofile.id))
        } 
    }

    const bulkBreakdownCallback = (item, type = 'all') => {
        setBreakdownRefId(item);
        setBreakdownType(type);
        setBreakdownDrawerVisible(true);
    };

    useEffect(() => {
            if (orders.bulkLabel && orders.bulkLabel.filename && orders.bulkLabel.filename !== "" && orders.bulkLabel.is_shown === false) {
                setPrintUrl(process.env.REACT_APP_LABELINGCHIMP_LABEL_API_DOMAIN + "/merge-pdf?filename=" + orders.bulkLabel.filename)
                setIsPrinted(false)
                setCheckedIds([])
                setCheckedItems([])
            }
    }, [orders.bulkLabel])

    const columns = [
        {
            field: '_id',
            headerName: 'Reference ID',
            sortable: false,
            minWidth: 200,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <Typography 
                    variant="body2" 
                    onClick={e => { bulkOrderCallback(params.row._id) }}
                    sx={{ 
                        color: '#1976d2', 
                        cursor: 'pointer', 
                        fontWeight: 700,
                        fontSize: '13.5px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        height: '100%',
                        '&:hover': { textDecoration: 'underline', color: '#115293' }
                    }}
                >
                    {params.row._id}
                </Typography>
            )
        },
        {
            field: 'upload_type',
            headerName: 'Type',
            sortable: false,
            minWidth: 180,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                const isOrder = params.row.upload_type && params.row.upload_type === 'ORDER';
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                        <Chip 
                            label={isOrder ? "ONLY ORDER" : "ORDER + SHIPMENT"} 
                            size="small"
                            sx={{ 
                                width: '150px',
                                height: '26px',
                                fontSize: '11px',
                                fontWeight: 700,
                                borderRadius: '6px',
                                backgroundColor: isOrder ? 'rgba(136, 78, 160, 0.08)' : 'rgba(21, 67, 96, 0.08)',
                                color: isOrder ? '#884EA0' : '#154360',
                                border: '1px solid',
                                borderColor: isOrder ? 'rgba(136, 78, 160, 0.2)' : 'rgba(21, 67, 96, 0.2)'
                            }}
                        />
                    </Box>
                );
            }
        },
        {
            field: 'status',
            headerName: 'Status',
            sortable: false,
            minWidth: 140,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                if (params.row.status == 'PENDING') {
                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                            <Chip 
                                label="PENDING" 
                                size="small"
                                sx={{ 
                                    width: '110px', height: '24px', fontSize: '11px', fontWeight: 700, borderRadius: '6px',
                                    backgroundColor: 'rgba(2, 136, 209, 0.08)', color: '#0288D1', border: '1px solid rgba(2, 136, 209, 0.2)'
                                }}
                            />
                        </Box>
                    );
                } else if (params.row.status == 'COMPLETED') {
                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                            <Chip 
                                label="COMPLETED" 
                                size="small"
                                sx={{ 
                                    width: '110px', height: '24px', fontSize: '11px', fontWeight: 700, borderRadius: '6px',
                                    backgroundColor: 'rgba(46, 125, 50, 0.08)', color: '#2E7D32', border: '1px solid rgba(46, 125, 50, 0.2)'
                                }}
                            />
                        </Box>
                    );
                } else {
                    return <Typography variant="body2" sx={{ color: '#94A3B8', display: 'inline-flex', alignItems: 'center', height: '100%' }}>—</Typography>;
                }
            }
        },
        /* ─── STANDALONE SEPARATE MATRIX SHIPPED COLUMNS (Unified directly on the baseline row) ─── */
        {
            field: 'shipments_total',
            headerName: 'Total',
            sortable: false,
            headerClassName: 'super-app-theme--header shipments-highlighted-header shipments-group-start',
            cellClassName: 'shipments-highlighted-column',
            minWidth: 145,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const success = parseInt(params.row.success_count) || 0;
                const failure = parseInt(params.row.failure_count) || 0;
                return (
                    <Typography variant="body2" sx={{ color: '#0F172A', fontWeight: 700, fontSize: '13.5px', display: 'inline-flex', alignItems: 'center', height: '100%' }}>
                        {success + failure}
                    </Typography>
                );
            }
        },
        {
            field: 'shipments_success',
            headerName: 'Success',
            sortable: false,
            headerClassName: 'super-app-theme--header shipments-highlighted-header',
            cellClassName: 'shipments-highlighted-column',
            minWidth: 115,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => (
                <Typography 
                    variant="body2" 
                    onClick={() => {
                        if (params.row._id) {
                            bulkBreakdownCallback(params.row._id);
                        }
                    }}
                    sx={{ 
                        color: '#2E7D32', 
                        fontWeight: 700, 
                        fontSize: '13.5px', 
                        display: 'inline-flex', 
                        alignItems: 'center', 
                        height: '100%',
                        cursor: 'pointer',
                        '&:hover': { 
                            textDecoration: 'underline',
                            color: '#1B5E20' 
                        }
                    }}
                >
                    {parseInt(params.row.success_count) || 0}
                </Typography>
            )
        },
        {
            field: 'shipments_failed',
            headerName: 'Failed',
            sortable: false,
            headerClassName: 'super-app-theme--header shipments-highlighted-header',
            cellClassName: 'shipments-highlighted-column',
            minWidth: 110,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const failure = parseInt(params.row.failure_count) || 0;
                return (
                    <Typography variant="body2" sx={{ color: failure > 0 ? '#D32F2F' : '#64748B', fontWeight: failure > 0 ? 700 : 500, fontSize: '13.5px', display: 'inline-flex', alignItems: 'center', height: '100%' }}>
                        {failure}
                    </Typography>
                );
            }
        },
        {
            field: 'shipments_scanned',
            headerName: 'Packed',
            sortable: false,
            headerClassName: 'super-app-theme--header shipments-highlighted-header',
            cellClassName: 'shipments-highlighted-column',
            minWidth: 110,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => (
                <Typography 
                    variant="body2" 
                    onClick={() => params.row._id && bulkBreakdownCallback(params.row._id, 'packed')}
                    sx={{ color: '#0F172A', fontWeight: 600, fontSize: '13.5px', display: 'inline-flex', alignItems: 'center', height: '100%', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                >
                    {parseInt(params.row.departure_scan_completed_count) || 0}
                </Typography>
            )
        },
        {
            field: 'shipments_not_scanned',
            headerName: 'Not Packed',
            sortable: false,
            headerClassName: 'super-app-theme--header shipments-highlighted-header shipments-group-end',
            cellClassName: 'shipments-highlighted-column',
            minWidth: 130,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const success = parseInt(params.row.success_count) || 0;
                const scanned = parseInt(params.row.departure_scan_completed_count) || 0;
                const notScanned = success - scanned;
                return (
                    <Typography 
                        variant="body2" 
                        onClick={() => params.row._id && bulkBreakdownCallback(params.row._id, 'not_packed')}
                        sx={{ color: notScanned > 0 ? '#EA580C' : '#64748B', fontWeight: notScanned > 0 ? 600 : 500, fontSize: '13.5px', display: 'inline-flex', alignItems: 'center', height: '100%', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                    >
                        {notScanned >= 0 ? notScanned : 0}
                    </Typography>
                );
            }
        },
        {
            field: 'notes',
            headerName: 'Notes',
            sortable: false,
            minWidth: 200,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <Typography variant="body2" sx={{ color: '#475569', fontWeight: 500, fontSize: '13px', display: 'inline-flex', alignItems: 'center', height: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {params.value || '—'}
                </Typography>
            )
        },
        {
            field: 'action',
            headerName: 'Action',
            sortable: false,
            minWidth: 140,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                const isCompleted = params.row.status == 'COMPLETED';
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, height: '100%' }}>
                        <Tooltip title="Edit Country of Origin" placement="top">
                            <IconButton 
                                onClick={() => cooEditAction(params.row._id)}
                                sx={{ 
                                    color: '#64748B', padding: '6px', borderRadius: '8px', border: '1px solid #E2E8F0', backgroundColor: '#FFFFFF',
                                    '&:hover': { backgroundColor: '#F1F5F9', borderColor: '#CBD5E1', color: '#1E293B' }
                                }}
                            >
                                <EditIcon sx={{ fontSize: '16px' }} />
                            </IconButton>
                        </Tooltip>
                        
                        <Tooltip title={isCompleted ? "Download Successful Shipments" : "Download unavailable"} placement="top">
                            <span>
                                <IconButton 
                                    disabled={!isCompleted}
                                    onClick={() => onExportClick(params.row._id)}
                                    sx={{ 
                                        padding: '6px', borderRadius: '8px', border: '1px solid',
                                        borderColor: isCompleted ? '#E2E8F0' : '#F1F5F9', 
                                        backgroundColor: '#FFFFFF',
                                        color: isCompleted ? '#1976d2' : '#CBD5E1',
                                        '&:hover': { 
                                            backgroundColor: isCompleted ? 'rgba(25, 118, 210, 0.04)' : '#FFFFFF', 
                                            borderColor: isCompleted ? '#CBD5E1' : '#F1F5F9' 
                                        }
                                    }}
                                >
                                    <FileDownloadIcon sx={{ fontSize: '16px' }} />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Box>
                );
            }
        },
        {
            field: 'created_at',
            headerName: 'Uploaded Date',
            minWidth: 180,
            flex: 1,
            renderCell: (params) => {
                if (params.row && params.row.created_at) {
                    return <Date date={params.row.created_at} />
                } else {
                    return "-"
                }
            }
        }
    ];

     // Function to disable selection on specific rows
        const isRowSelectable = (params) => {
            // Disable row selection where the status is 'inactive'
            return typeof params.row.bulk_label_url !== 'undefined';
        };

    const onSortChange = (currentSorting) => {
        setMeta({
            ...meta,
            ...{
                sorting: JSON.stringify(currentSorting)
            }
        });
    }

    const onChangePerPage = (event) => {
        setPageNumber('')
        setMeta({
            ...meta,
            ...{
                page: 1,
                per_page: event.target.value
            }
        });
        setCheckedIds([])
        setCheckedItems([])
    }

    const onChangePagination = (event, page) => {
        setPageNumber('')
        setMeta({
            ...meta,
            ...{
                page: page
            }
        });
        setCheckedIds([])
        setCheckedItems([])
    }

    const onInputChangePagination = (page) => {
        setPageNumber(page)
        let pagenumber = ''
        if (page == '') {
            pagenumber = 1
        } else {
            pagenumber = page
        }
        setMeta({
            ...meta,
            ...{
                page: pagenumber
            }
        });
    }

    // ==========================================
    // PART 1: SUB-COMPONENTS ARCHITECTURE (TOOLBAR & PAGINATION)
    // ==========================================

    function CustomTotalRows() {
        return (
            <Box 
                className="custom-total-rows" 
                sx={{ 
                    display: 'inline-flex', 
                    alignItems: 'center',
                    py: 0.6,
                    px: 1.5,
                    borderRadius: '8px',
                    backgroundColor: '#F1F5F9', 
                    border: '1px solid #E2E8F0'
                }}
            >
                <Typography 
                    variant="body2" 
                    sx={{ 
                        fontSize: '12.5px', 
                        fontWeight: 600, 
                        color: '#475569',
                        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                        letterSpacing: '0.1px'
                    }}
                >
                    Showing <strong style={{ color: '#0F172A', fontWeight: 700 }}>
                        {bulkorder && bulkorder.data && bulkorder.data.length}
                    </strong> of <strong style={{ color: '#0F172A', fontWeight: 700 }}>
                        {(bulkorder && bulkorder.meta && bulkorder.meta.total) ? bulkorder.meta.total : 0}
                    </strong>
                </Typography>
            </Box>
        );
    }

    function CustomPagesizeoptions() {
        return (
            <Box className="custom-page-size-options" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                <Stack direction="row" spacing={1.2} alignItems="center">
                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748B' }}>
                        Show
                    </Typography>
                    
                    <FormControl 
                        size="small" 
                        variant="outlined" 
                        sx={{
                            minWidth: 75,
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                                backgroundColor: '#FFFFFF',
                                transition: 'all 0.2s',
                                border: '1px solid #E2E8F0',
                                '& fieldset': { border: 'none' },
                                '&:hover': { borderColor: '#CBD5E1' },
                                '&.Mui-focused': {
                                    borderColor: '#1976d2',
                                    boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
                                }
                            },
                            '& .MuiSelect-select': {
                                padding: '6px 10px',
                                fontSize: '13px',
                                fontWeight: 600,
                                color: '#1E293B',
                                textAlign: 'center'
                            }
                        }}
                    >
                        <Select
                            // FIXED: Added a safe Number casting wrap to reconcile string vs integer discrepancies on boot
                            value={meta && meta.per_page ? Number(meta.per_page) : 10}
                            onChange={onChangePerPage}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        borderRadius: '8px',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                                        border: '1px solid #E2E8F0',
                                        '& .MuiMenuItem-root': {
                                            fontSize: '13px',
                                            fontWeight: 500,
                                            py: 0.8,
                                            color: '#334155',
                                            '&.Mui-selected': {
                                                backgroundColor: 'rgba(25, 118, 210, 0.08)',
                                                color: '#1976d2',
                                                fontWeight: 700
                                            }
                                        }
                                    }
                                }}
                            }
                        >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                        </Select>
                    </FormControl>

                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748B' }}>
                        entries
                    </Typography>
                </Stack>
            </Box>
        );
    }

    function CustomToolbar() {
        return (
            <GridToolbarContainer
                sx={{ 
                    p: 2, 
                    bgcolor: '#F8FAFC', 
                    borderBottom: '1px solid #E2E8F0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    width: '100%',
                    boxSizing: 'border-box',
                    gap: 2
                }}
            >
                <CustomPagesizeoptions />
                <CustomTotalRows />
            </GridToolbarContainer>
        );
    }

    function CustomPagination() {
        return (
            <GridFooterContainer 
                sx={{
                    p: 1.5,
                    bgcolor: '#F8FAFC',
                    borderTop: '1px solid #E2E8F0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    width: '100%',
                    boxSizing: 'border-box',
                    '& .MuiPaginationItem-root': {
                        fontSize: '13px',
                        fontWeight: 600,
                        borderRadius: '8px',
                        '&.Mui-selected': {
                            backgroundColor: '#1976d2', // --- CORPORATE BLUE AXIS SIGNATURE ACCENT ---
                            color: '#FFFFFF',
                            '&:hover': {
                                backgroundColor: '#115293'
                            }
                        }
                    }
                }}
            >
                <Pagination
                    color="primary"
                    shape="circular"
                    page={bulkorder && bulkorder.meta && bulkorder.meta.current_page}
                    count={bulkorder && bulkorder.meta && bulkorder.meta.last_page}
                    onChange={onChangePagination}
                />
                <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
                    <PageSearch 
                        pagenumber={pageNumber} 
                        lastPage={bulkorder?.meta?.last_page || 1} 
                        getpagenumber={onInputChangePagination} 
                    />
                </Box>
            </GridFooterContainer>
        );
    }


    useEffect(() => {
        dispatch(fetchBulkOrderReference(meta))
        dispatch(fetchCountry());
        setValues(initialValues)
        setErrors({})
    }, [meta]);

    const onMenuClick = (type, show) => {
        setShowSearch((type === "search" && show === true) ? true : false)
        setShowFilter((type === "filter" && show === true) ? true : false)
    }
    const onChangeCountry = id => {
        setValues({
            ...values,
            ['coo']: id
        })
        setErrors({ "coo": "" })
    }
    const onChangeCooUpdate = (e) => {
        setValues({
            ...values,
            ['update']: e.target.value
        })
    }
    const getSelectedCountry = (country_code) => {
        let filteredValue = { code: "", name: "" };
        filteredCountryData.map((key) => {
          if (key.code == country_code) {
            filteredValue = key;
          }
        });
         return filteredValue;
      };

      const handleSubmit = e => {
        e.preventDefault()
        const isValid = validator(values)
        if (isValid) {
            let bulkid={}
            bulkid["_id"] = bulkReferenceId;
            Object.assign(values, bulkid);
            dispatch(bulkReferenceCooUpdateData(getprofile.id,values))
            setCooModalVisible(false)
            setValues(initialValues)
            setErrors({})
            setBulkReferenceId('')
        }
    }
    return (
        <>
            {(bulkorder  && bulkorder.notification && bulkorder.notification.show) &&
                    <Notification
                        is_open={bulkorder.notification.show}
                        messageType={bulkorder.notification.messageType}
                        messages={bulkorder.notification.messageContent}
                        handleClose={() => dispatch(resetBulkOrderNotifications())}
                    />}
             {(cooUpdate  && cooUpdate.notification && cooUpdate.notification.show) &&
                    <Notification
                        is_open={cooUpdate.notification.show}
                        messageType={cooUpdate.notification.messageType}
                        messages={cooUpdate.notification.messageContent}
                        handleClose={() => dispatch(resetBulkOrderNotifications())}
             />}
            
            <Printer isPrinted={isPrinted} setIsPrinted={setIsPrinted} print_url={printUrl} />


            <Modal
                open={cooModalVisible}
                onClose={() => setCooModalVisible(false)} // Better UX: click outside to close
                aria-labelledby="modal-modal-title"
            >
                <Box sx={{
                    ...tagstyle,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    outline: 'none'
                }}>
                    <Card sx={{ width: 650, borderRadius: '12px', boxShadow: '0 8px 32px rgba(0,0,0,0.12)' }}>
                        <CardHeader 
                            title={<Typography variant="h6" sx={{ fontWeight: 700 }}>Bulk Update Line Items</Typography>} 
                            sx={{ backgroundColor: '#f9fafb', borderBottom: '1px solid #e5e7eb', py: 1.5 }}
                        />
                        <CardContent sx={{ p: 3 }}>
                            {/* Info Alert */}
                            <Alert severity="info" sx={{ mb: 3, borderRadius: '8px' }}>
                                Updating details for <strong>{bulkReferenceId || 'selected'}</strong> items. Provide at least one field to update.
                            </Alert>

                            <Grid container spacing={3}>
                                {/* Country of Origin */}
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="caption" sx={{ fontWeight: 700, color: '#374151', mb: 0.5, display: 'block' }}>
                                        COUNTRY OF ORIGIN
                                    </Typography>
                                    <Autocomplete
                                        options={filteredCountryData}
                                        getOptionLabel={(option) => option.name}
                                        value={getSelectedCountry(values.coo)}
                                        onChange={(e, val) => setValues({ ...values, coo: val ? val.code : "" })}
                                        renderInput={(params) => (
                                            <TextField 
                                                {...params} 
                                                placeholder="Select Country"
                                                variant="outlined" 
                                                size="small"
                                                error={!!errors.coo}
                                                helperText={errors.coo}
                                            />
                                        )}
                                    />
                                </Grid>

                                {/* HS Tariff Code */}
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="caption" sx={{ fontWeight: 700, color: '#374151', mb: 0.5, display: 'block' }}>
                                        HS TARIFF CODE
                                    </Typography>
                                    <TextField
                                        placeholder="e.g. 6109.10.00.12"
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        value={values.hs_tariff_code}
                                        onChange={(e) => setValues({ ...values, hs_tariff_code: e.target.value })}
                                        onBlur={handleHsBlur}
                                        error={!!errors.hs_tariff_code}
                                        helperText={errors.hs_tariff_code || "10 digit numeric code"}
                                    />
                                </Grid>

                                {/* Update Scope */}
                                <Grid item xs={12}>
                                    <Divider sx={{ my: 1 }} />
                                    <Typography variant="caption" sx={{ fontWeight: 700, color: '#374151', mt: 1, display: 'block' }}>
                                        UPDATE SCOPE
                                    </Typography>
                                    <RadioGroup
                                        name="update"
                                        value={values.update}
                                        onChange={(e) => setValues({ ...values, update: e.target.value })}
                                    >
                                        <FormControlLabel 
                                            value="All" 
                                            control={<Radio size="small" />} 
                                            label={<Typography variant="body2">Update <b>ALL</b> line items in this reference</Typography>} 
                                        />
                                        <FormControlLabel 
                                            value="Not Exist" 
                                            control={<Radio size="small" />} 
                                            label={<Typography variant="body2">Update only items with <b>missing</b> data</Typography>} 
                                        />
                                    </RadioGroup>
                                </Grid>
                            </Grid>

                            {/* Footer Buttons */}
                            <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end', gap: 1.5 }}>
                                <Button 
                                    variant="text" 
                                    sx={{ color: '#6b7280', fontWeight: 600 }}
                                    onClick={() => { 
                                        setCooModalVisible(false);
                                        setValues(initialValues);
                                        setErrors({});
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button 
                                    variant="contained" 
                                    disabled={!values.coo && !values.hs_tariff_code}
                                    onClick={handleSubmit}
                                    sx={{ 
                                        px: 4, 
                                        borderRadius: '6px', 
                                        boxShadow: 'none',
                                        fontWeight: 700,
                                        textTransform: 'none'
                                    }}
                                >
                                    Apply Changes
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
            </Modal>
            <div className="scmaincard">
                <Box 
                    className="sccardhead"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        p: 2.5,
                        borderBottom: '1px solid #E2E8F0',
                        backgroundColor: '#FFFFFF',
                        flexWrap: 'wrap',
                        gap: 2
                    }}
                >
                    {/* Title Typography Matrix */}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography 
                            variant="h5" 
                            gutterBottom 
                            component="div"
                            sx={{ 
                                fontWeight: 800, 
                                color: '#0F172A',
                                letterSpacing: '-0.5px',
                                margin: 0
                            }}
                        >
                            Bulk Order
                        </Typography>
                    </Box>

                    {/* Operational Tool Controls Pipeline */}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Stack 
                            component="ul" 
                            className="features-list" 
                            direction="row" 
                            spacing={1} 
                            sx={{ listStyle: 'none', p: 0, m: 0, alignItems: 'center' }}
                        >
                            {(checkedIds && checkedIds.length >= 1) &&
                                <Box component="li">
                                    <Tooltip title="Bulk Print" placement="top">
                                        <IconButton 
                                            onClick={() => printLabelBulk()}
                                            sx={{ 
                                                color: '#1976d2', 
                                                borderRadius: '8px', 
                                                border: '1px solid #E2E8F0', 
                                                p: 1, 
                                                transition: 'all 0.15s ease-in-out',
                                                '&:hover': { backgroundColor: '#F1F5F9', color: '#115293', borderColor: '#CBD5E1' }
                                            }}
                                        >
                                            <LocalPrintshopIcon sx={{ fontSize: '18px' }} />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            }
                            <Box component="li">
                                <Tooltip title="Bulk orders upload" placement="top">
                                    <IconButton 
                                        onClick={bulkOrderCreateCallback}
                                        sx={{ 
                                            color: '#1976d2', 
                                            borderRadius: '8px', 
                                            border: '1px solid #E2E8F0', 
                                            p: 1, 
                                            transition: 'all 0.15s ease-in-out',
                                            '&:hover': { backgroundColor: '#F1F5F9', color: '#115293', borderColor: '#CBD5E1' }
                                        }}
                                    >
                                        <UploadFileOutlinedIcon sx={{ fontSize: '18px' }} />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            <Box component="li">
                                <Tooltip title="Seacrh" placement="top">
                                    <IconButton 
                                        onClick={() => onMenuClick("search", !showSearch)}
                                        sx={{ 
                                            color: showSearch ? '#1976d2' : '#64748B', 
                                            borderRadius: '8px', 
                                            border: '1px solid',
                                            borderColor: showSearch ? 'rgba(25, 118, 210, 0.2)' : '#E2E8F0', 
                                            p: 1, 
                                            transition: 'all 0.15s ease-in-out',
                                            backgroundColor: showSearch ? 'rgba(25, 118, 210, 0.04)' : '#FFFFFF',
                                            '&:hover': { backgroundColor: showSearch ? 'rgba(25, 118, 210, 0.08)' : '#F1F5F9', color: showSearch ? '#115293' : '#1E293B' }
                                        }}
                                    >
                                        <SearchIcon sx={{ fontSize: '18px' }} />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            {/* <li>
                                <Tooltip title="Filter" placement="top-start">
                                    <IconButton onClick={() => onMenuClick("filter", !showFilter)}>
                                        <FilterAltOutlinedIcon style={{ color: 'rgb(25, 118, 210)' }} />
                                    </IconButton>
                                </Tooltip>
                            } */}
                        </Stack>
                    </Box>
                </Box>
                <Search visible={showSearch} meta={meta} setMeta={setMeta} />
                <Filters visible={showFilter} meta={meta} setMeta={setMeta} />
                <Box 
                    sx={{ 
                        backgroundColor: '#FFFFFF', 
                        marginTop: "20px", 
                        width: '100%',
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                        overflow: 'hidden'
                    }}
                >
                    <DataGrid
                        sx={{
                            border: 'none',
                            backgroundColor: '#FFFFFF',
                            overflow: 'hidden',
                            
                            '& .MuiDataGrid-topContainer': {
                                backgroundColor: '#F8FAFC',
                                '&::after': { display: 'none' }
                            },
                            
                            // Customizing Single-Row Enterprise Header Styling
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#F8FAFC',
                                borderBottom: '1px solid #E2E8F0',
                                minHeight: '52px !important',
                                maxHeight: '52px !important'
                            },
                            '& .MuiDataGrid-columnHeader': {
                                color: '#475569',
                                fontWeight: 700,
                                fontSize: '13px',
                                textTransform: 'none',
                                letterSpacing: '0.1px',
                                '&:focus, &:focus-within': {
                                    outline: 'none'
                                }
                            },

                            // Pure Single-Row Header visual tinting and demarcation
                            '& .shipments-highlighted-header': {
                                backgroundColor: '#F0FDF4 !important', // Soft light green header backdrop
                                '& .MuiDataGrid-columnHeaderTitleContainer': {
                                    overflow: 'visible !important' // Ensures customized title rows render correctly
                                }
                            },
                            '& .shipments-group-start': {
                                borderLeft: '1px solid #DCFCE7 !important'
                            },
                            '& .shipments-group-end': {
                                borderRight: '1px solid #DCFCE7 !important'
                            },
                            
                            // Customizing Rows, Cells and Selection Background States
                            '& .MuiDataGrid-row': {
                                transition: 'background-color 0.15s ease-in-out',
                                borderBottom: '1px solid #F1F5F9',
                                alignItems: 'center',
                                '&:hover': {
                                    backgroundColor: '#F8FAFC',
                                    '& .shipments-highlighted-column': { backgroundColor: '#E8F5F0' }
                                },
                                '&.Mui-selected': {
                                    backgroundColor: 'rgba(25, 118, 210, 0.04)',
                                    '& .shipments-highlighted-column': { backgroundColor: '#EBF4F0' },
                                    '&:hover': {
                                        backgroundColor: 'rgba(25, 118, 210, 0.08)',
                                        '& .shipments-highlighted-column': { backgroundColor: '#E1EFEA' }
                                    }
                                }
                            },
                            '& .MuiDataGrid-cell': {
                                fontSize: '13.5px',
                                color: '#334155',
                                borderBottom: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                py: '12px', 
                                '&:focus, &:focus-within': {
                                    outline: 'none'
                                }
                            },
                            '& .shipments-highlighted-column': {
                                backgroundColor: '#F4FBF7',
                                borderRight: '1px dashed rgba(226, 232, 240, 0.6) !important'
                            },

                            // Global Selection Checkbox Interactive Customization
                            '& .MuiCheckbox-root': {
                                color: '#CBD5E1',
                                '&.Mui-checked': {
                                    color: '#1976d2'
                                }
                            },

                            // Custom Linear Progress bar tracking layout styling overrides
                            '& .MuiLinearProgress-root': {
                                height: '3px',
                                backgroundColor: '#E2E8F0',
                                '& .MuiLinearProgress-bar': {
                                    backgroundColor: '#1976d2'
                                }
                            }
                        }}
                        getRowId={(row) => row._id}
                        rows={bulkorder && bulkorder.data}
                        columns={columns}
                        autoHeight={true}
                        disableColumnFilter={true}
                        disableColumnMenu={true}
                        sortingMode="server"
                        checkboxSelection
                        onRowSelectionModelChange={(newSelectionModel) => { onSelectionChange(newSelectionModel, bulkorder && bulkorder.data) }}
                        rowSelectionModel={checkedIds}
                        onSortModelChange={(newSortModel) => onSortChange(newSortModel)}
                        sortModel={meta && meta.sorting && JSON.parse(meta.sorting)}
                        disableRowSelectionOnClick
                        isRowSelectable={isRowSelectable}
                        slots={{
                            loadingOverlay: LinearProgress,
                            footer: CustomPagination,
                            toolbar: CustomToolbar,
                            NorowsData
                        }}
                        loading={
                            (bulkorder && bulkorder.loading) || (cooUpdate && cooUpdate.loading) ||
                            (orders && orders.bulkLabel && orders.bulkLabel.loading) 
                        }
                    />
                </Box>

            </div>
            {bulkdrawershow &&
            <BulkOrderDrawer visible={bulkOrderDrawerVisible} referenceId={referenceId} bulkDraweronClose={bulkOrderOnClose} checkReload={bulkOrderCallback}
            />
            }
            <BulkOrderCreateDrawer
                visible={bulkOrderCreateDrawerVisible} onClose={bulkOrderCreateOnClose}
            />
            <BulkOrderDetailsDrawer 
                visible={breakdownDrawerVisible}
                bulkReferenceId={breakdownRefId}
                type={breakdownType}
                onClose={setBreakdownDrawerVisible}
            />
        </>
    );
}

export default BulkOrderPage;
